import { useEffect, useRef, useState } from 'react';

import type { FC } from 'react';

import { cometChatSession } from '@/services/cometChatSession';

type WidgetProps = {
  chatId?: string;
  hideChat: boolean;
  sessionId: string;
  setChatId: (val: string) => void;
};

const Widget: FC<WidgetProps> = ({
  hideChat,
  chatId = '',
  sessionId,
  setChatId,
}) => {
  const [ready, setReady] = useState(false);
  const callbacks = useRef({ setChatId });
  callbacks.current = { setChatId };

  useEffect(
    () =>
      cometChatSession.start({
        onClose: () => callbacks.current.setChatId(''),
        onReady: () => setReady(true),
        onReset: () => {
          setReady(false);
          callbacks.current.setChatId('');
        },
        uid: sessionId,
      }),
    [sessionId],
  );

  useEffect(() => {
    if (ready) cometChatSession.openChat(sessionId, chatId);
  }, [sessionId, chatId, ready]);

  useEffect(() => {
    cometChatSession.setHidden(sessionId, hideChat || !ready);
  }, [sessionId, hideChat, ready]);

  return <div id="cometchat" />;
};

export default Widget;
